import React from "react";
import { SearchBox } from "components/helpers/searchBox/SearchBox";
import { TableInfo } from "api";
import FilterIcon from "assets/Icon_Table_Filter_01.png";
import FilterActiveIcon from "assets/Icon_Table_Filter.png";
import { getFileFromURL } from "helpers/getFileFromURL";
import { downloadUploadedFile } from "pages/AddBulk";
import { AxiosRequestConfig } from "axios";

export type PageHeaderProps = {
  pageTitle: string;
  table: TableInfo;
  disableListSearch?: boolean;
  changeSearch?(searchString: string): void;
  initialSearchString: string;
  addButtonText: string;
  onAddButtonClick?(): void;
  onOpenFilters?: any;
  hideHeaderTitle?: boolean;
  addBulkButtonText?: string;
  onAddBulkButtonClick?(): void;
  showFilterButton?: boolean;
  filterButtonOnClick?(): void;
  listCSV?: { url: string; noun: string };
  overridePageTitle?: string;
  programmeFilter?: JSX.Element;
  customButtons?: JSX.Element[];
  fetchConfig?: AxiosRequestConfig<any> | undefined;
  styleClass?: string;
  disableAddButton?: boolean;
  defaultBActiveFilterColumnKey?: string;
};

const downloadCsvList = async (
  url: string,
  noun: string,
  fetchConfig?: AxiosRequestConfig<any> | undefined
) => {
  getFileFromURL(url, "test_file.csv", fetchConfig)
    .then((file) => {
      downloadUploadedFile(file, "text/csv", `${noun}_list.csv`);
    })
    .catch(() => {
      // setDownloadError(true);
    });
};

const PageHeader: React.FC<PageHeaderProps> = ({
  pageTitle,
  table,
  disableListSearch,
  changeSearch,
  initialSearchString,
  addButtonText,
  onAddButtonClick,
  hideHeaderTitle,
  addBulkButtonText,
  onAddBulkButtonClick,
  showFilterButton,
  filterButtonOnClick,
  listCSV,
  overridePageTitle,
  programmeFilter,
  customButtons,
  fetchConfig,
  styleClass,
  disableAddButton,
  defaultBActiveFilterColumnKey,
}) => {
  let filters = false;

  if (table.data && table.data.details.filters.length > 0) {
    filters = true;

    if (defaultBActiveFilterColumnKey) {
      const defaultFilterMatch = table.data.details.filters.filter(
        (item) => item.columnKey === defaultBActiveFilterColumnKey
      );
      // defaultFilterMatch[0].filters.

      if (
        table.data.details.filters.length === 1 &&
        defaultFilterMatch &&
        defaultFilterMatch.length === 1 &&
        defaultFilterMatch[0].filters &&
        Array.isArray(defaultFilterMatch[0].filters) &&
        defaultFilterMatch[0].filters.length === 1 &&
        typeof defaultFilterMatch[0].filters[0] === "object" &&
        defaultFilterMatch[0].filters[0].columnKey === defaultBActiveFilterColumnKey &&
        defaultFilterMatch[0].filters[0].operator === "EQ" &&
        defaultFilterMatch[0].filters[0].value === "1"
      ) {
        filters = false;
      }
    }
  }

  return (
    <div className={`PageHeader ${styleClass && styleClass}`}>
      {!hideHeaderTitle && <h1 style={{ marginBottom: "0" }}>{overridePageTitle ?? pageTitle}</h1>}
      <div className={"HeaderActionsContainer"}>
        {(table?.data?.details as any).bHasSearchField && !disableListSearch && (
          <SearchBox
            key={initialSearchString}
            onSearchStringChange={changeSearch}
            initialSearchString={initialSearchString}
            goToPage={table.data?.actions.goToPage}
            loading={table?.loading}
          />
        )}
        <div className="Buttons">
          {onAddButtonClick && !disableAddButton && (
            <button className="Btn BtnAdd " onClick={onAddButtonClick}>
              <div className="Text">{addButtonText}</div>
            </button>
          )}

          {addBulkButtonText && onAddBulkButtonClick && (
            <button className="Btn BtnAdd BtnUpload" onClick={onAddBulkButtonClick}>
              <div className="Text">{addBulkButtonText}</div>
            </button>
          )}
          {listCSV && (
            <button
              className="Btn BtnAdd BtnCSV"
              onClick={async () => await downloadCsvList(listCSV?.url, listCSV?.noun, fetchConfig)}
            >
              <div className="Text">{`Download list csv`}</div>
            </button>
          )}

          {customButtons &&
            customButtons.map((item) => {
              return item;
            })}

          {showFilterButton && (
            <div
              className="FilterButtonContainer"
              onClick={() => {
                if (filterButtonOnClick) {
                  filterButtonOnClick();
                }
              }}
            >
              <img
                className={`FilterIcon`}
                src={filters ? FilterActiveIcon : FilterIcon}
                alt="Filter"
              />
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export { PageHeader };
